import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, Phone } from "lucide-react";
import SEO from "../../components/SEO";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="notfound-page">
      <SEO
        title="الصفحة غير موجودة (404)"
        description="الصفحة المطلوبة غير موجودة. تواصل مع ونش انقاذ محمد بحر على مدار الساعة 01044844492 لخدمة انقاذ ورفع السيارات في جميع انحاء مصر."
        path="/404"
        noindex
      />
      <div className="notfound-content">
        <div className="notfound-code">404</div>
        <h1 className="notfound-title">الصفحة غير موجودة</h1>
        <p className="notfound-text">
          عذراً، الصفحة التي تبحث عنها غير متاحة. لكن خدمة الإنقاذ متاحة على مدار الساعة!
        </p>
        <div className="notfound-actions">
          <a href="tel:+201044844492" className="notfound-call-btn">
            <Phone size={20} />
            اتصل الآن: 01044844492
          </a>
          <Link to="/" className="notfound-home-btn">
            <HomeIcon size={20} />
            العودة للرئيسية
          </Link>
        </div>
        <div className="notfound-links">
          <Link to="/services">خدماتنا</Link>
          <span>·</span>
          <Link to="/areas">مناطق الخدمة</Link>
          <span>·</span>
          <Link to="/articles">المقالات</Link>
          <span>·</span>
          <Link to="/contact">اتصل بنا</Link>
        </div>
      </div>
    </div>
  );
}
